<template>
  <div
      v-loading="loading"
      class="feature-flags-page"
      style="margin: 90px;">
    <el-header style="height: 100px;  margin-top: 20px;">
      <span
          class="ring-card__header-buttons"
          style="margin: 0px 0px 20px 0px; float: right;">
        <RefreshButton @click.native="refresh(true)" />
      </span>
      <div style="text-align: center; color: #1998d5">
        <h2>Manage Feature Flags</h2>
      </div>
    </el-header>
    <div style="height: 50px;">
      <el-tooltip content="Create Feature-Flag">
        <el-button
            size="medium"
            type="primary"
            plain
            style="float: right;font-size: 14px;"
            @click="openCreateFFDialog()">
          <i class="el-icon-plus"></i>
          Create
        </el-button>
      </el-tooltip>
      <el-input
          v-model="filter"
          placeholder="Find by Key, Name or Description"
          style="font-size: 14px; margin: 0px 10px 20px 0px; float: right; width: 300px;"
          clearable
          type="text">
        <i
            slot="prefix"
            class="el-input__icon el-icon-search" />
      </el-input>
    </div>
    <el-table
        :data="FeatureFlagsList"
        style="width: 100%">
      <el-table-column
          label="Key"
          prop="key">
        <template slot-scope="featureFlagItem">
          <span>
            {{ featureFlagItem.row.key }}
          </span>
          <div
              label="id"
              prop="id">
          </div>
        </template>
      </el-table-column>
      <el-table-column
          label="Name"
          prop="name">
        <template slot-scope="featureFlagItem">
          <span>
            {{ featureFlagItem.row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="Description"
          prop="description">
        <template slot-scope="featureFlagItem">
          <span>
            {{ featureFlagItem.row.description }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          align="right">
        <template slot-scope="featureFlagItem">
          <el-tooltip
              content="Cannot update an active feature-flag"
              placement="top"
              :disabled="!featureFlagItem.row.active">
            <el-button
                type="default"
                size="mini"
                icon="el-icon-edit"
                :disabled="featureFlagItem.row.active"
                @click="openUpdateFFDialog(featureFlagItem.row)" />
          </el-tooltip>
          <el-tooltip
              :content="'Cannot delete an active feature-flag' "
              placement="top"
              :disabled="!featureFlagItem.row.active">
            <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                :disabled="featureFlagItem.row.active"
                @click="openDeleteFFDialog(featureFlagItem.row)" />
          </el-tooltip>
          <el-switch
              v-model="featureFlagItem.row.active"
              style="margin: 5px 5px 0px 10px" 
              @change="updateFeatureFlag(featureFlagItem.row, false)" />
        </template>
      </el-table-column>
    </el-table>
    <!-- Delete Feature Flag Dialog   -->
    <el-dialog
        :visible.sync="dialogDeleteFFVisible"
        width="30%"
        :show-close="true">
      <span style="margin-left: 40px">
        <img
            :src="icons.warning"
            class="icon">
      </span>
      <span class="dialog_title_style">
        Delete this Feature-Flag?
      </span>
      <div style="padding: 30px">
        <div class="dialog_item_style">
          <span style="margin-right: 40px">Key:</span><b>{{ featureFlag.key }} </b>
        </div>
        <div class="dialog_item_style">
          <span style="margin-right: 20px">Name:</span><b>{{ featureFlag.name }}</b>
        </div>
        <div class="dialog_item_style">
          <span style="margin-right: 40px">Description:</span><b>{{ featureFlag.description }} </b>
        </div>
      </div>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="dialogDeleteFFVisible = false">Cancel</el-button>
        <el-button
            type="primary"
            @click="deleteFeatureFlag(featureFlag.id);">Confirm</el-button>
      </span>
    </el-dialog>
    <!-- Create Feature Flag Dialog   -->
    <el-dialog
        :visible.sync="dialogCreateFFVisible"
        width="30%"
        :show-close="true">
      <div class="dialog_title_style">
        Create Feature Flag
      </div>
      <form
          :model="featureFlagForm"
          :disabled="!featureFlagForm.resource"
          class="dialog_create_form_style"
          @submit.prevent="createFeatureFlag(featureFlagForm)">
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Key:
          </div>
          <el-input
              v-model="featureFlagForm.key"
              required
              placeholder="Key"
              input="string"
              style="max-width: 400px;"
              class="custom-placeholder" />
        </div>
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Name:
          </div>
          <el-input
              v-model="featureFlagForm.name"
              required
              placeholder="Name"
              input="string"
              style="max-width: 400px;"
              class="custom-placeholder" />
        </div>
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Description:
          </div>
          <el-input
              v-model="featureFlagForm.description"
              required
              placeholder="Detail the Feature flag purpose"
              input="string"
              style="max-width: 400px;"
              class="custom-placeholder" />
        </div>
        <div class="dialog_create_item_style">
          Enabled:
          <el-switch
              v-model="featureFlagForm.active"
              style="margin: 5px 40px 0px 10px" />
        </div>
      </form>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="dialogCreateFFVisible = false">Cancel</el-button>
        <el-button
            type="primary"
            :disabled="!featureFlagForm.key || !featureFlagForm.name || !featureFlagForm.description"
            @click="createFeatureFlag(featureFlagForm)">Create</el-button>
      </span>
    </el-dialog>
    <!-- Update Feature Flag Dialog   -->
    <el-dialog
        :visible.sync="dialogUpdateFFVisible"
        width="30%"
        :show-close="true">
      <div class="dialog_title_style">
        Update Feature Flag
      </div>
      <form
          ref="ruleForm"
          :model="featureFlagForm"
          :disabled="!featureFlagForm.resource"
          class="dialog_create_form_style"
          @submit.prevent="updateFeatureFlag(featureFlagForm, true)">
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Key:
          </div>
          <el-input
              v-model="featureFlagForm.key"
              required
              placeholder="Key"
              input="string"
              style="max-width: 400px;"
              class="custom-placeholder" />
        </div>
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Name:
          </div>
          <el-input
              v-model="featureFlagForm.name"
              required
              placeholder="Name"
              input="string"
              style="max-width: 400px;"
              class="custom-placeholder" />
        </div>
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Description:
          </div>
          <el-input
              v-model="featureFlagForm.description"
              required
              input="string"
              style="max-width: 400px;"
              class="custom-placeholder" />
        </div>
        <div class="dialog_create_item_style">
          Enabled:
          <el-switch
              v-model="featureFlagForm.active"
              style="margin: 5px 40px 0px 10px" />
        </div>
      </form>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="dialogUpdateFFVisible = false">Cancel</el-button>
        <el-button
            type="primary"
            :disabled="!featureFlagForm.key || !featureFlagForm.name || !featureFlagForm.description"
            @click="updateFeatureFlag(featureFlagForm, true)">Update</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RefreshButton from "@/containers/Customer/RefreshButton";
import { createNamespacedHelpers as h } from "vuex";
import axios from "axios";
import { startCase } from "lodash";
const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");

export default {
  name: "FeatureFlags",
  components: {
    RefreshButton,
  },
  data() {
    return {
      filter: "",
      featureFlagsList: [],
      loading: false,
      featureFlag: {
        id: "",
        key: "",
        name: "",
        description: "",
        active: false,
      },
      featureFlagForm: {
        id: null,
        key: null,
        name: null,
        description: null,
        active: false,
      },
      dialogDeleteFFVisible: false,
      dialogCreateFFVisible: false,
      dialogUpdateFFVisible: false,
      icons: {
        warning: require("@/assets/icons/new-ui/customer/authorizations/shared/warning.svg"),
      },
    };
  },
  computed: {
    ...sharedGetters(["feature_flags", "roles"]),
    FeatureFlagsList() {
      const regex = new RegExp(this.filter, "i");
      return this.featureFlagsList.filter((p) => {
        return (
          regex.test(p.name) || regex.test(p.key) || regex.test(p.description)
        );
      });
    },
  },
  created() {
    this.isAdmin();
    this.loadFeatureFlags();
  },
  methods: {
    ...sharedActions(["fetchFeatureFlags"]),
    goBack() {
      this.$router.go(-1);
    },
    refresh() {
      this.loadFeatureFlags();
    },
    loadFeatureFlags() {
      this.loading = true;
      this.fetchFeatureFlags()
        .then((_) => {
          this.featureFlagsList = this.feature_flags.features.map((item) => {
            return {
              ...item,
              editable: false,
            };
          });
        })
        .catch((_) => {
          this.$message.warning({
            title: "FeatureFlags",
            message: "Couldn't be loaded. Reload the page.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isAdmin: function () {
      if (!this.$store.getters["auth/isAdmin"]) {
        this.$router.back();
      }
    },
    createFeatureFlag(feature_flag) {
      let payload = {
        flag: {
          name: feature_flag.name,
          key: feature_flag.key,
          description: feature_flag.description,
          active: feature_flag.active,
        },
      };
      axios
        .post(`/admin_configurations/flags`, payload)
        .then((response) => {
          this.$message({
            title: "Success",
            message: `Feature-Flag Created`,
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            title: "Error",
            message: "Something went wrong! Try again.",
            type: "error",
          });
        })
        .finally(() => {
          this.featureFlagForm = {
            key: null,
            name: null,
            description: null,
            active: false,
          };
          this.dialogCreateFFVisible = false;
          this.loadFeatureFlags();
        });
    },
    updateFeatureFlag(feature_flag, reload) {
      let payload = feature_flag;
      return axios
        .patch(`/admin_configurations/flags/${feature_flag.id}`, payload)
        .then((response) => {
          this.$message({
            title: "Success",
            message: `${startCase(feature_flag.name)} Updated`,
            type: "success",
          });
        })
        .catch((error) => {
          console.log(error.data);
          this.$message({
            title: "Error",
            message:
              error.data.name != undefined
                ? error.data.name
                : `Cannot update ${startCase(feature_flag.name)}`,
            type: "error",
          });
        })
        .finally(() => {
          this.$emit("reload");
          if (reload) {
            this.dialogUpdateFFVisible = false;
            this.loadFeatureFlags();
          }
        });
    },
    deleteFeatureFlag(feature_flag) {
      axios
        .delete(`/admin_configurations/flags/${feature_flag}`, {})
        .then((response) => {
          this.$message({
            title: "Success",
            message: `Feature-Flag Deleted`,
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            title: "Error",
            message: "Something went wrong! Try again.",
            type: "error",
          });
        })
        .finally(() => {
          this.dialogDeleteFFVisible = false;
          this.loadFeatureFlags();
        });
    },
    openCreateFFDialog() {
      this.dialogCreateFFVisible = true;
      this.featureFlagForm = {
        key: null,
        name: null,
        description: null,
        active: false,
      };
    },
    openUpdateFFDialog(uff) {
      this.dialogUpdateFFVisible = true;
      this.featureFlagForm.id = uff.id;
      this.featureFlagForm.key = uff.key;
      this.featureFlagForm.name = uff.name;
      this.featureFlagForm.description = uff.description;
      this.featureFlagForm.active = uff.active;
    },
    openDeleteFFDialog(dff) {
      this.dialogDeleteFFVisible = true;
      this.featureFlag.id = dff.id;
      this.featureFlag.key = dff.key;
      this.featureFlag.name = dff.name;
      this.featureFlag.description = dff.description;
      this.featureFlag.key = dff.active;
    },
  },
};
</script>
<style lang="scss" scoped>
.feature-flags-page {
  margin: 0px !important;
  padding: 0px 50px;
  background: #fff;
}
.el-table::before {
  width: 0% !important;
}
.dialog_title_style {
  font-size: 22px;
  position: static;
  margin-left: 25px;
  margin-bottom: 5px;
  font-weight: 500;
  line-height: 36px;
}
.dialog_item_style {
  font-size: 16px;
  position: inherit;
  margin-left: 12px;
  margin-top: 5px;
  font-weight: 500;
  line-height: 36px;
}
.dialog_create_item_style {
  font-size: 16px;
  position: inherit;
  margin: 20px 0px 0px 20px;
  font-weight: 500;
}
.dialog_create_item_title_style {
  padding-bottom: 2%;
}
.dialog_create_form_style {
  margin: 65px 0px 0px 20px;
}
.el-switch {
  -ms-flex-align: center;
  position: relative;
  font-size: 14px;
  line-height: 22px;
  height: 20px;
  float: right;
}
.custom-placeholder ::placeholder {
  font-size: 14px;
}
.invalid {
  border: 2px solid red;
}
</style>
